module.exports = __webpack_public_path__ + "img/noData.a23fa868.png";